import logoutIcon from 'assets/icons/logout.svg'
// LogoutPopoverContent.tsx
import { Button, FlexColumn, FlexRow, Image, Text } from 'styles/generics'
import styled, { useTheme } from 'styled-components'
import { useAppDispatch, useAppSelector } from 'store/store'
import { logout } from 'services/AuthService'
import { useNavigate } from 'react-router-dom'
import { EAppRoutes } from 'types/enums/EAppRoutes'
import { MouseEvent } from 'react'
import { setIsAuthenticated } from 'store/reducers/userReducer'
import { ThemeInterface } from 'styles/theme'

const LogoutPopoverContent = () => {
  const theme = useTheme() as ThemeInterface
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const userFullName = useAppSelector(
    (state) =>
      state.user.personalDetails?.firstName +
      ' ' +
      state.user.personalDetails?.lastName,
  )

  const onLogout = (ev: MouseEvent<HTMLButtonElement>) => {
    ev.stopPropagation()
    ev.preventDefault()
    dispatch(setIsAuthenticated(false))
    logout()
    navigate(EAppRoutes.LOGIN)
  }

  return (
    <FlexColumn>
      <UserNameRow width="138px" gap={10}>
        <UserIconContainer>
          <ProfileIconContainer>
            {/* <ProfileIcon src={profileIcon} alt="user" /> */}
          </ProfileIconContainer>
        </UserIconContainer>
        <Text weight={500} color={theme.colors.black} fontSize="16px">
          {userFullName}
        </Text>
      </UserNameRow>
      <LogoutRow onClick={onLogout}>
        <Image src={logoutIcon} alt="logout" />
        <Text fontSize="14px" weight={400}>
          התנתק
        </Text>
      </LogoutRow>
    </FlexColumn>
  )
}

// Styled components definitions
const UserNameRow = styled(FlexRow)`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grayBorder}`};
  padding-bottom: 5px;
`

const UserIconContainer = styled.div`
  position: relative;
  width: 27px;
`

const ProfileIconContainer = styled.div`
  position: absolute;
  width: 18px;
  top: 57%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const LogoutRow = styled(Button)`
  gap: 17px;
  justify-content: flex-start;
  margin-top: 14px;
  height: 30px;
  align-items: center;
  padding-inline-start: 4px;
  cursor: pointer;
  border-radius: 3px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightBlack};
  }
`

export { LogoutPopoverContent }
